var hosturl = require('url');
var globalconfig = require('../../globalconfig');
var adr = window.location.href;
var parseUrlName = hosturl.parse(adr, true);
// localhost has no white-label data of its own — fall back to the domain
// baked into globalconfig.js so local testing hits real per-domain data
// instead of sending "localhost:<port>" to APIs that expect a real domain.
var urlName = parseUrlName.hostname === 'localhost'
    ? hosturl.parse(globalconfig.server).host
    : parseUrlName.host;

module.exports = {
    urlName: urlName
}